import React, { Fragment, useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteItineraryFoodInvoice } from '../../../../actions/food/ItineraryFoodInvoice';

const DeleteItineraryFoodInvoiceButton = ({
  itineraryFoodInvoiceId,
  dispatchDeleteItineraryFoodInvoice,
}) => {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  const onClickDelete = () => {
    dispatchDeleteItineraryFoodInvoice(itineraryFoodInvoiceId);
    closeModal();
  };

  return (
    <Fragment>
      <Button color="danger" onClick={openModal}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>

      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
    </Fragment>
  );
};

DeleteItineraryFoodInvoiceButton.propTypes = {
  itineraryFoodInvoiceId: PropTypes.number.isRequired,
  dispatchDeleteItineraryFoodInvoice: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteItineraryFoodInvoice: deleteItineraryFoodInvoice,
};

export default connect(
  null,
  mapDispatchToProps,
)(DeleteItineraryFoodInvoiceButton);
